/* UNIKE LOVE · LP KIT JS — Motion One reveals + premium micro-interactions (compartido) */
(function(){
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = matchMedia('(hover:hover) and (pointer:fine)').matches; // desktop con mouse

  // nav scrolled
  var nav=document.getElementById('nav');
  if(nav){addEventListener('scroll',function(){nav.classList.toggle('scrolled',scrollY>10)},{passive:true});}

  // sticky mobile CTA: aparece tras pasar el hero
  var sc=document.querySelector('.sticky-cta');
  if(sc){
    var heroEl=document.querySelector('.hero');
    addEventListener('scroll',function(){
      var past=heroEl?(heroEl.getBoundingClientRect().bottom<0):(scrollY>500);
      sc.classList.toggle('show',past);
    },{passive:true});
  }

  /* ---------- count-up de números (auto, salta placeholders) ---------- */
  function countUp(el){
    if(el.children.length) return;                 // no romper markup (ph-txt, etc.)
    var raw=el.textContent.trim();
    if(raw.indexOf('[')>-1) return;                // placeholder pendiente
    var m=raw.match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/);
    if(!m) return;
    var pre=m[1], numStr=m[2], suf=m[3];
    var hasComma=numStr.indexOf(',')>-1;
    var dec=((numStr.split('.')[1])||'').length;
    var target=parseFloat(numStr.replace(/,/g,''));
    if(!isFinite(target)) return;
    function fmt(v){
      var s=dec?v.toFixed(dec):Math.round(v).toString();
      if(hasComma){var p=s.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');s=p.join('.');}
      return pre+s+suf;
    }
    if(RM){el.textContent=fmt(target);return;}
    var dur=1100, start=null;
    el.textContent=fmt(0);
    function step(t){
      if(start===null)start=t;
      var p=Math.min((t-start)/dur,1), e=1-Math.pow(1-p,3);
      el.textContent=fmt(target*e);
      if(p<1)requestAnimationFrame(step); else el.textContent=fmt(target);
    }
    requestAnimationFrame(step);
  }

  /* ---------- tilt 3D (solo desktop, en visuales de producto) ---------- */
  function addTilt(el){
    var MAX=7;
    el.addEventListener('pointermove',function(e){
      var r=el.getBoundingClientRect();
      var px=(e.clientX-r.left)/r.width-0.5, py=(e.clientY-r.top)/r.height-0.5;
      el.style.transition='';
      el.style.transform='perspective(820px) rotateX('+(-py*MAX).toFixed(2)+'deg) rotateY('+(px*MAX).toFixed(2)+'deg)';
    });
    el.addEventListener('pointerleave',function(){
      el.style.transition='transform .55s cubic-bezier(.16,1,.3,1)';
      el.style.transform='';
    });
  }

  /* ---------- CTA magnético (solo desktop, no en sticky) ---------- */
  function addMagnetic(btn){
    var S=0.28;
    btn.addEventListener('pointermove',function(e){
      var r=btn.getBoundingClientRect();
      var dx=e.clientX-(r.left+r.width/2), dy=e.clientY-(r.top+r.height/2);
      btn.style.transition='';
      btn.style.transform='translate('+(dx*S).toFixed(1)+'px,'+(dy*S).toFixed(1)+'px)';
    });
    btn.addEventListener('pointerleave',function(){
      btn.style.transition='transform .45s cubic-bezier(.16,1,.3,1)';
      btn.style.transform='';
    });
  }

  if(FINE && !RM){
    document.querySelectorAll('.hero-vis .imgslot, .plate, .shape, .gc').forEach(addTilt);
    document.querySelectorAll('.btn-primary').forEach(function(b){ if(!b.closest('.sticky-cta')) addMagnetic(b); });
  }

  /* ---------- reveals + count-up (Motion One) ---------- */
  if(!window.Motion){
    // sin Motion: contar igual al entrar (o de una si RM)
    document.querySelectorAll('.ts .v, .stat .v, .b-stat .v, .float .n').forEach(countUp);
    return;
  }
  var animate=Motion.animate, inView=Motion.inView, stagger=Motion.stagger;
  var EASE=[0.16,1,0.3,1];

  var all=document.querySelectorAll('[data-rv]');
  all.forEach(function(el){el.style.opacity=0;el.style.transform='translateY(24px)';});

  var hero=document.querySelectorAll('.hero [data-rv]');
  if(hero.length) animate(hero,{opacity:1,transform:'translateY(0px)'},{duration:.7,delay:stagger(.07,{start:.05}),easing:EASE});

  all.forEach(function(el){
    if(el.closest('.hero')) return;
    inView(el,function(){ animate(el,{opacity:1,transform:'translateY(0px)'},{duration:.6,easing:EASE}); },{margin:'0px 0px -12% 0px'});
  });

  // count-up al entrar en viewport
  document.querySelectorAll('.ts .v, .stat .v, .b-stat .v, .float .n').forEach(function(el){
    inView(el,function(){ countUp(el); },{margin:'0px 0px -8% 0px'});
  });
})();
